
export class OS {
    constructor(
        public id: number,
        public origem: string,
        public tipoOS: string,
       
        public requisitante: string,
        public servicoExecutar: string,
        public oSPrecedenteId: number | null = null,
        public pTId: number | null,
        public spvId: number | null,
        public spvAprovadoId: number,
        public tipoOSFilha: number,
        public empreiteiraId: number,
        public encarregadoResponsavelId: number,
        public engenheiroResponsavelId: number,
        public equipamentoId: number,
        public atividadeId: number,
        public localId: number,
        public atividade: any,
        public prioridadeId: number,
        public areaTecnicaId: number,
        public Qualificado: string
       

    ) { }
}
